/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_CtaInputs */

const en_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So what's the fix?`)
};

const de_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Und was hilft da?`)
};

const zh_tw_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那要怎麼解決？`)
};

const zh_cn_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那要怎么解决？`)
};

const es_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Y cómo lo resuelvo?`)
};

const fr_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et on fait comment ?`)
};

const it_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E come si risolve?`)
};

const pt_br_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E como resolver?`)
};

const ja_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どうすればいいの？`)
};

const ko_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그럼 어떻게 해요?`)
};

const ru_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`И что с этим делать?`)
};

const th_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แล้วทำยังไงดี?`)
};

const tr_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peki çözüm ne?`)
};

const ar_problem_cta = /** @type {(inputs: Problem_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وما الحل؟`)
};

/**
* | output |
* | --- |
* | "So what's the fix?" |
*
* @param {Problem_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_cta = /** @type {((inputs?: Problem_CtaInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_CtaInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_cta(inputs)
	if (locale === "de") return de_problem_cta(inputs)
	if (locale === "zh_tw") return zh_tw_problem_cta(inputs)
	if (locale === "zh_cn") return zh_cn_problem_cta(inputs)
	if (locale === "es") return es_problem_cta(inputs)
	if (locale === "fr") return fr_problem_cta(inputs)
	if (locale === "it") return it_problem_cta(inputs)
	if (locale === "pt_br") return pt_br_problem_cta(inputs)
	if (locale === "ja") return ja_problem_cta(inputs)
	if (locale === "ko") return ko_problem_cta(inputs)
	if (locale === "ru") return ru_problem_cta(inputs)
	if (locale === "th") return th_problem_cta(inputs)
	if (locale === "tr") return tr_problem_cta(inputs)
	return ar_problem_cta(inputs)
});